import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { typesActiviteApi } from '../api/types-activite.api'
import type { CreateTypeActiviteRequest, UpdateTypeActiviteRequest } from '@/shared/types/admin'

const TYPES_ACTIVITE_KEY = ['types-activite']

export function useTypesActivite() {
  return useQuery({
    queryKey: TYPES_ACTIVITE_KEY,
    queryFn: typesActiviteApi.getAll,
    select: (data) => [...data].sort((a, b) => a.libelle.localeCompare(b.libelle)),
  })
}

export function useTypeActivite(id: number | undefined) {
  return useQuery({
    queryKey: [...TYPES_ACTIVITE_KEY, id],
    queryFn: () => typesActiviteApi.getById(id!),
    enabled: !!id,
  })
}

export function useCreateTypeActivite() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateTypeActiviteRequest) => typesActiviteApi.create(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TYPES_ACTIVITE_KEY }),
  })
}

export function useUpdateTypeActivite() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateTypeActiviteRequest }) =>
      typesActiviteApi.update(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TYPES_ACTIVITE_KEY }),
  })
}

export function useDeleteTypeActivite() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => typesActiviteApi.delete(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TYPES_ACTIVITE_KEY }),
  })
}
